export function merge(target: Record<any, any>, source: Record<any, any>) {
  const result = { ...target }

  Object.keys(source).forEach((key) => {
    const sourceValue = source[key]
    const targetValue = target[key]

    if (sourceValue === undefined && key in target) {
      // Skip if source value is undefined and the key exists in the target
      return
    } else if (isObject(targetValue) && isObject(sourceValue)) {
      // Recursively merge objects
      result[key] = merge(targetValue, sourceValue)
    } else if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
      // Concatenate arrays
      result[key] = targetValue.concat(sourceValue)
    } else {
      // For other types, directly assign the source value
      result[key] = sourceValue
    }
  })

  return result
}

function isObject(value: any): value is Record<any, any> {
  return Object.prototype.toString.call(value) === '[object Object]' && value !== null
}
